module.exports = __webpack_public_path__ + "assets/img/a1.5f2d2ff6.jpg";